import { CenturionBottomNav } from "@/components/centurion/CenturionShell";
import { HallBanner } from "@/components/centurion/NumeralCard";
import { BackCoin } from "@/components/centurion/ThemedPageHeader";
import NextLevelCard from "@/components/dashboard/NextLevelCard";
import { useUserProfile } from "@/hooks/useUserProfile";

/** Next Level as its own page: stage checklist, next step, Foundation. */
export default function NextLevelPage() {
  const { data: profile } = useUserProfile() as any;
  const gender = profile?.gender === "female" ? "female" : "male";
  return (
    <main className="min-h-screen overflow-x-hidden pb-28 text-foreground" style={{ background: "radial-gradient(ellipse at 50% 0%, hsl(var(--card)), hsl(var(--background)))" }}>
      <div className="px-3 pt-3 pb-2"><BackCoin to="/dashboard" label="Kingdom Hub" /></div>
      <HallBanner title="Next Level" tagline="Higher standards · A brighter you" />
      <div className="mx-auto max-w-3xl px-3 sm:px-6 pt-4">
        <NextLevelCard gender={gender} />
      </div>
      <CenturionBottomNav dark />
    </main>
  );
}
